export default __webpack_public_path__ + "2a590a710ba0f7e7dc5995c1067fe92c.png";